import React from 'react';
import CompleteForm from '../CompleteForm';

/**
 * Export a component that render login page.
 */

const ChangePassword = () => {
	return (
		<CompleteForm name='Passwort ändern' requestPath='/login/changePassword' showOldPasswordField={true} showPasswordField={true} showCopiedPasswordField={true} showEmail={true} showSubmitButton={true} submitButton='Bestätigen' />
	);
};

export default ChangePassword;
